import { HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestService } from '@commonServices/request.service';
import { Client as AnalyticsApi, ExportsCountAvgDto, ExportsCountDto, ExportsCountPerDateDto, ExportsCountPerMonthDto, ExportsCountPerWeekDto } from '@interfaces/HttpClient/AnalyticsApiModels';
import { firstValueFrom } from 'rxjs';
import { DaterangeService } from './daterange.service';

@Injectable({
	providedIn: 'root'
})
export class OrcaAdminExportService {

	constructor(
		private analyticsApi: AnalyticsApi,
		private requestService: RequestService,
		private daterangeService: DaterangeService) { }

	async getExportsCount(): Promise<ExportsCountDto> {
		try {
			return firstValueFrom(this.analyticsApi.orcaAdminExportDetails_GetExportsCount((await this.daterangeService.rangeInfo)?.rangeStart, (await this.daterangeService.rangeInfo)?.rangeEnd));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async getExportCountAverages(): Promise<ExportsCountAvgDto> {
		try {
			return firstValueFrom(this.analyticsApi.orcaAdminExportDetails_GetExportsCountAVG((await this.daterangeService.rangeInfo)?.rangeStart, (await this.daterangeService.rangeInfo)?.rangeEnd));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async getExportsCountDaily(): Promise<ExportsCountPerDateDto[]> {
		try {
			return firstValueFrom(this.analyticsApi.orcaAdminExportDetails_GetExportsCountPerDate((await this.daterangeService.rangeInfo)?.rangeStart, (await this.daterangeService.rangeInfo)?.rangeEnd));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async getExportsCountWeekly(): Promise<ExportsCountPerWeekDto[]> {
		try {
			return firstValueFrom(this.analyticsApi.orcaAdminExportDetails_GetExportsCountPerWeek((await this.daterangeService.rangeInfo)?.rangeStart, (await this.daterangeService.rangeInfo)?.rangeEnd));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async getExportsCountMonthly(): Promise<ExportsCountPerMonthDto[]> {
		try {
			return firstValueFrom(this.analyticsApi.orcaAdminExportDetails_GetExportsCountPerMonth((await this.daterangeService.rangeInfo)?.rangeStart, (await this.daterangeService.rangeInfo)?.rangeEnd));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}
}
